// extracted by mini-css-extract-plugin
export default {"checker":"UsedCheckers_checker__pXfRz"};